<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

// 팝업 설정 — 이벤트마다 이 값만 바꾸면 됨
const POPUP = {
  id: "hangul-day-2026",
  image: "/popup/hangul-day-2026.jpg", // public/popup/ 아래에 이미지 배치
  alt: "롯데리아 한글잔치에 초대하노라! 2026.10.1 ~ 10.11 롯데리아 홍대점, 잠실월드몰B1점, 서울역사점",
  link: "", // 클릭 시 이동할 URL (없으면 빈 문자열)
  // 노출 기간 (KST). startAt 이전·endAt 이후엔 자동 비노출 — 행사 기간 10/1~10/11 기준
  startAt: "2026-10-01T00:00:00+09:00",
  endAt: "2026-10-12T00:00:00+09:00",
};

const HIDE_KEY = `popup-hide-until:${POPUP.id}`;
const visible = ref(false);

const isHiddenToday = () => {
  try {
    const until = Number(localStorage.getItem(HIDE_KEY));
    return until && Date.now() < until;
  } catch (e) {
    return false;
  }
};

onMounted(() => {
  const now = Date.now();
  const inPeriod =
    now >= new Date(POPUP.startAt).getTime() &&
    now < new Date(POPUP.endAt).getTime();
  visible.value = inPeriod && !isHiddenToday();
  if (visible.value) window.addEventListener("keydown", onKeydown);
});

onBeforeUnmount(() => window.removeEventListener("keydown", onKeydown));

const close = () => {
  visible.value = false;
  window.removeEventListener("keydown", onKeydown);
};

function onKeydown(e) {
  if (e.key === "Escape") close();
}

const hideToday = () => {
  const midnight = new Date();
  midnight.setHours(24, 0, 0, 0);
  try {
    localStorage.setItem(HIDE_KEY, String(midnight.getTime()));
  } catch (e) {
    // 저장 불가 환경이면 이번 방문에서만 닫힘
  }
  close();
};
</script>

<template>
  <div v-if="visible" class="event-popup" @click.self="close">
    <div
      class="event-popup__box"
      role="dialog"
      aria-modal="true"
      :aria-label="POPUP.alt"
    >
      <a
        v-if="POPUP.link"
        :href="POPUP.link"
        target="_blank"
        rel="noopener noreferrer"
        class="event-popup__link"
      >
        <img :src="POPUP.image" :alt="POPUP.alt" class="event-popup__img" />
      </a>
      <img
        v-else
        :src="POPUP.image"
        :alt="POPUP.alt"
        class="event-popup__img"
      />

      <div class="event-popup__footer">
        <button type="button" @click="hideToday">오늘 하루 보지 않기</button>
        <button type="button" @click="close">닫기</button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.event-popup {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.6);

  &__box {
    width: fit-content;
    max-width: min(480px, 100%);
    background: #fff;
    overflow: hidden;
  }

  &__link {
    display: block;
  }

  &__img {
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: calc(100vh - 120px);
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    background: #222;

    button {
      flex: 1;
      padding: 14px 16px;
      border: 0;
      background: none;
      color: #fff;
      font-size: 14px;
      cursor: pointer;

      & + button {
        border-left: 1px solid #444;
      }
    }
  }
}
</style>
